import { Crosshair, Gauge, Settings2, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { ASSETS, CEO } from "../data/content";

const pillars = [
  { icon: Crosshair, title: "Inspection", body: "Defense artillery equipment inspection to approved quality assurance plans." },
  { icon: Gauge, title: "Testing", body: "Rigorous testing in accordance with international codes and standards." },
  { icon: Settings2, title: "Commissioning", body: "End-to-end commissioning support by experienced engineering executives." },
];

export const CoreStrength = () => (
  <section
    id="core-strengths"
    data-testid="core-strength-section"
    className="relative overflow-hidden bg-[#0A192F] py-24 lg:py-32"
  >
    <img
      src={ASSETS.artillery}
      alt="Defense artillery equipment"
      className="absolute inset-0 h-full w-full object-cover opacity-25"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/94 to-[#0A192F]/70" />

    <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12">
        <Reveal className="lg:col-span-6">
          <SectionLabel tone="light">Our Ultimate Core Strength</SectionLabel>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-[1.1] tracking-tight text-white">
            Defense artillery equipment{" "}
            <span className="text-[#D4AF37]">inspection, testing and commissioning.</span>
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-slate-300">
            {CEO.highlight}
          </p>
          <a
            href="#contact"
            data-testid="core-strength-cta"
            className="group mt-10 inline-flex items-center gap-2 border-b border-[#D4AF37] pb-1 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]"
          >
            Discuss a defense project
            <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform duration-300" />
          </a>
        </Reveal>

        <div className="lg:col-span-6 lg:pl-10">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={0.1 + i * 0.1}>
              <div
                data-testid={`core-pillar-${i}`}
                className="flex gap-6 border-b border-white/10 py-8 first:pt-0 last:border-0"
              >
                <div className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-[#22D3EE]/40 bg-[#22D3EE]/5">
                  <p.icon size={19} className="text-[#22D3EE]" />
                </div>
                <div>
                  <h3 className="font-display text-base font-bold uppercase tracking-[0.18em] text-white">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-400">{p.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
